const route = [
    {
        path: '/activity/sf_clock/index', //2023书法打卡活动判断状态，选择班级
        component: function (resolve) {
            require(['VIEWS/activity/sf_clock/index.vue'], resolve);
        },
    },
    {
        path: '/activity/sf_clock/home/:unit_class_id', //2023书法打卡活动
        component: function (resolve) {
            require(['VIEWS/activity/sf_clock/home.vue'], resolve);
        },
    },
    {
        path: '/activity/sf_clock/rank/:unit_class_id', //2023书法打卡活动
        component: function (resolve) {
            require(['VIEWS/activity/sf_clock/ranking.vue'], resolve);
        },
    },
]
export default route;
